import { render } from "./Percent.vue?vue&type=template&id=1cc71ef1"
import script from "./Percent.vue?vue&type=script&lang=ts"
export * from "./Percent.vue?vue&type=script&lang=ts"
script.render = render

export default script